import './App.css';
import AgeCalculator from './components/AgeCalculator/AgeCalculator'

function App() {
  return (
    <main role="main">
      <AgeCalculator />
    </main>
  );
}

export default App;
